module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0021.jpg?v=a3db7032";